
import React, { ReactElement, useState, useEffect } from 'react';
import Image from '@components/Image';
import { useDispatch, useSelector } from 'react-redux';
import UpsellDetailsModal from '@components/UpsellDetailsModal';
import * as actions from '@redux-actions/';
import { convertNumber, getItemDiscountedTotalPrice, getItemTotalPrice, getInsuranceBenefits, getDiscountNames, getInsuranceCode, handleHTTPError, scrollUpPage, isThereAnAddedWarranty } from '@utils/utils';
import  { addToCart, deleteOrderItem, sendPrescription, calculateProductInsuranceBenefit, addWarranty,orderCalculate } from '@utils/services';
import Cookies from 'js-cookie';
import Loader from '@components/Loader';

type UpsellElementProps = {
    upsellEspot: any;
    upsellType: any;
    upsellOption: any;
    itemCart:any;
    orderId:any;
}

declare global {
    interface Window {
         tealium_data2track: any;
    }
}

const UpsellElement = (props: UpsellElementProps) : ReactElement => {

    const {
        upsellEspot,
        upsellType,
        upsellOption,
        itemCart,
        orderId
    } = props;

    const [upsellModal, setUpsellModal] = useState(false);
    const [insuranceDeltaPrice, setInsuranceDeltaPrice] = useState(null);
    const dispatch = useDispatch();
    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);
    const speedyOrderDetails = useSelector(state => state.cart.speedyOrderDetails);


    const activeModalUpsell = () => {
        setUpsellModal(true);
        document.getElementById('header_wrapper').setAttribute("style", "z-index:0;");
        document.getElementById('footer_wrapper').setAttribute("style", "z-index:0 !important; display:block;");
    }

    const deactiveModalUpsell = () => {
        setUpsellModal(false);
        document.getElementById('header_wrapper').removeAttribute("style");
        document.getElementById('footer_wrapper').removeAttribute("style");
        document.getElementById('footer_wrapper').setAttribute("style","display:block;");
    }

    const getPrescriptionData = (frameOrderItemId, prscriptionObject) => {
        const dataToSend = {
            "frameOrderItemId": frameOrderItemId,
            "cyl_od": prscriptionObject.rightCyl,
            "cyl_os": prscriptionObject.leftCyl,
            "sph_od": prscriptionObject.rightSphere,
            "sph_os": prscriptionObject.leftSphere,
            "axis_od": prscriptionObject.rightAxis,
            "axis_os": prscriptionObject.leftAxis,
            "add_od": prscriptionObject.rightAdd,
            "add_os": prscriptionObject.leftAdd,
            "pd_od": prscriptionObject.pupillaryDistance,
            "prismEnabled": prscriptionObject.prismEnable,
            "vPrism_os": prscriptionObject.osVPrism,
            "vPrism_od": prscriptionObject.odVPrism,
            "vBaseDir_os": prscriptionObject.osVPrismBaseDir,
            "vBaseDir_od": prscriptionObject.odVPrismBaseDir,
            "hPrism_os": prscriptionObject.osHPrism,
            "hPrism_od": prscriptionObject.odHPrism,
            "hBaseDir_os": prscriptionObject.osHPrismBaseDir,
            "hBaseDir_od": prscriptionObject.odHPrismBaseDir,
            "FILE_NAME": prscriptionObject.fileName
        };
        return dataToSend;
    }

    const getAddToCartParams = (upsell) => {
        var params = new URLSearchParams();
        params.append('storeId', config.storeId);
        params.append('catalogId', config.catalogId);
        params.append('langId', config.langId);
        params.append('orderId', '');
        params.append('frameCatentryId', itemCart.frame.productId);
        params.append('URL', '');
        params.append('lensCatentryId',  upsell.lensPackage.catEntryId);
        params.append('lensColor', '');
        params.append('lensBrand', upsell.lensPackage.brand);
        params.append('lensTreatmentFamily', upsell.lensPackage.treatmentFamily);
        params.append('lensBlueLight', upsell.lensPackage.blueLight);
        params.append('lensInfoServices', JSON.stringify(upsell.lensPackage.services));
        params.append('lensMaterialCode', upsell.lensPackage.materialCode);
        params.append('lensSegmentCode', upsell.lensPackage.segmentCode);
        params.append('lensIndex', upsell.lensPackage.index);
        params.append('lensAntiReflective', upsell.lensPackage.antiReflective);
        params.append('correctionType', upsell.lensPackage.type);
        params.append('lensUpc', upsell.lensPackage.upc);
        params.append('includeLens', 'true');
        params.append('rxcReviewObject', JSON.stringify(upsell.reviewObject));
        params.append('rxcImagery', JSON.stringify(upsell.imagery));
        params.append('config', JSON.stringify(itemCart.frame.xitem_rxcUpsellConfig));
        params.append('lensIsSpeedyRx', upsell.lensPackage.isSpeedyRX && (itemCart.prescription?.isPrescrSpeedyRxEl == 'true'));
        params.append('isSpeedySelected', speedyOrderDetails?.orderSpeedyActive.toString());
        params.append('prescriptionIsSpeedyRx', itemCart.prescription?.isPrescrSpeedyRxEl);

        return params;
    }

    const handleSessionStorageUpsell = (response, upsellTitle) => {
        sessionStorage.setItem("upsell-current-session-title-" + response.frameOrderItemId, upsellTitle);
            if(sessionStorage.getItem("upsell-current-session-title-"+ itemCart.frame.orderItemId) != undefined){
                sessionStorage.removeItem("upsell-current-session-title-"+ itemCart.frame.orderItemId);
            }
    }

    const handleCalculateUpsellInsurancePrice = () => {
        setInsuranceDeltaPrice(null);
        var ria_1_cookie = Cookies.get('ria_1');
        let upsellDiscountedPrice = '0';
        if(itemCart.frame.hasInsuranceCalculated === true && !!ria_1_cookie) {                  
            var riaInfo = JSON.parse(ria_1_cookie).riaInsuranceInformation;
            var basePricingEntry = {
                frame: {
                    price: String(itemCart.frame.finalPrice),
                    quantity: '1',
                    type: 'f',
                    upc: itemCart.frame.partNumber,
                },
                lens: {
                    price: upsellOption.lensPackage.listPrice,
                    quantity: '1',
                    type: 'l',
                    upc: upsellOption.lensPackage.upc,
                },
            };
            var riaParams = {
                "catalogId": config.catalogId,
                "__PRICING_ENTRY": JSON.stringify(basePricingEntry),
                "__RIA_SYNC_TOKEN": JSON.parse(ria_1_cookie).token,
                "__RIA_SYNC_INFO": JSON.stringify(JSON.parse(riaInfo)),
                "__RIA_SYNC_FAKECALL": true
            }
            calculateProductInsuranceBenefit(config.hostname, config.catalogId, riaParams).then(response => {
                var frameDiscountedPrice = response[0].frame.price - response[0].frameDiscount;
                var lensDiscountedPrice = response[0].lens.price - response[0].lensDiscount;
                upsellDiscountedPrice = String(frameDiscountedPrice + lensDiscountedPrice);
                setInsuranceDeltaPrice(convertNumber(parseFloat(upsellDiscountedPrice) - parseFloat(getItemDiscountedTotalPrice(itemCart))));
            })
        }
    }
    useEffect(() => {
        handleCalculateUpsellInsurancePrice();
    }, [itemCart.frame.hasInsuranceCalculated]);

    useEffect(() => {
        handleCalculateUpsellInsurancePrice();
    }, [itemCart.frame.orderItemId]);

    const handleAddUpsellToCart = (upsell, upsellTitle) => {
        dispatch(actions.startLoading());

        deleteOrderItem(config.hostname,
            {
                "storeId": config.storeId,
                "orderId": ".",
                "orderItemId": itemCart.frame.orderItemId, 
                "calculationUsage": "-1,-2,-4,-5,-6,-7",
                "forGiftItem": ""
            }
        ).then((response) => {
            console.log("Upsell removed by cart");

            var params = getAddToCartParams(upsell);

            addToCart(config.hostname, params).then(async (response) => {
                console.log("Upsell added to cart");
                makeOrderCalculate();
                              
                if(isThereAnAddedWarranty(cart, itemCart.frame.orderItemId)){
                    const warrantyServiceParams = {
                        "orderId": orderId,
                        "orderItemId": response.frameOrderItemId,
                        "action": "ADD",
                        "lensType": itemCart.correction_type == "Progressive" ? "Progressive" : "Single Vision",
                    };
                    await addWarranty(config.hostname, warrantyServiceParams).then((res: any) => {
                        dispatch(actions.getCart(config.mockRequests, config.hostname));
                    });
                }
    
                //PROVO A MANDARE GLI ANALYTICS
                sendAnalyticsAddToCartUpsell(upsell, response.frameOrderItemId);
                console.log("Analytics Sent");
                
                const dataToSend = getPrescriptionData(response.frameOrderItemId, itemCart.prescription);
                handleSessionStorageUpsell(response, upsellTitle);

                dispatch(actions.setSpeedyDetails(config.hostname, props.orderId));

                await sendPrescription(
                    config.hostname,
                    dataToSend
                ).then((res: any) => {
                    if(res.status === 200) {
                        scrollUpPage(window);
                        if (itemCart.frame.hasInsuranceCalculated) {
                            makeOrderCalculate();
                        } else {
                            dispatch(actions.getCart(config.mockRequests, config.hostname));
                            dispatch(actions.setSpeedyDetails(config.hostname, props.orderId));
                            dispatch(actions.setDisableNavigation(-1));
                        }
                        console.log("Cart updated after sendPrescription");
                    }
                }).catch(err => {
                    console.error('>>> Send prescription => error status:', err.status, ', error: ', err);
                    handleHTTPError(dispatch, actions, err);
                    dispatch(actions.errorLoading());
                })
            }).catch(err => {
                console.error('>>> Upsell Add to cart Error => error status:', err.status, ', error: ', err);
                handleHTTPError(dispatch, actions, err);
            })
            
        }).catch(err => {
            console.error('>>> Upsell Remove item Upsell Error => error status:', err.status, ', error: ', err);
            handleHTTPError(dispatch, actions, err);
        })
    }

    const sendAnalyticsAddToCartUpsell = async(upsell, orderItemId) => {
        const prodAn = {};

        prodAn[orderItemId] = populateAnalytics(upsell);
      
        var obj={};
        try {
           obj = {
            id: 'Event',
            Events_CartAdd: '1',
            Products: prodAn
          }
          window?.tealium_data2track?.push(obj);
        }catch(err){
           obj = {
            'id' : 'AddToCart-Tentative',
            'Error_Source' : 'Product',
            'Error_Code' : 'UPC Update'
          };
        }        
      }

     const getItemTotalPriceUpsell = (item) => {      
        return(parseFloat(item.frame.finalPrice) + parseFloat(upsellOption.lensPackage.listPrice)).toFixed(2);
      }

      const getItemDiscountedTotalPriceUpsell = (item) => {
        if(item.frame.hasInsuranceCalculated){
            return (parseFloat(insuranceDeltaPrice) + parseFloat(getItemDiscountedTotalPrice(itemCart))).toFixed(2);
        }else{
            return (parseFloat(item.frame.finalDiscountPrice) + parseFloat(upsellOption.lensPackage.offerPrice)).toFixed(2);
        }
    }

      //getInsuranceAmount - this function get insurance amount for data object
    const getInsuranceAmount = (el) => {
        if(!el.adjustment || el.adjustment.length === 0) return '0.00';

        const ins = el.adjustment.find(adj => adj.code === 'INSADJ');
        if(!!ins) {
            return convertNumber(ins.amount);
        } else {
            return '0.00';
        }
    }

    const populateAnalytics = (upsell) => {
        var obj = {
            Status: itemCart.buyable_frame ? 'Available' : 'Sold out',
            LensUPC: !!itemCart.partNumber_lenses ? itemCart.partNumber_lenses.replace('_SKU', '') : '', 
            Category:
                itemCart?.moCo?.prod_hierarchy_1 &&
                    typeof itemCart.moCo.prod_hierarchy_1 === 'string' &&
                    itemCart.moCo.prod_hierarchy_1.toLowerCase() === 'electronics'
                    ? 'Electronics'
                    : itemCart?.frame?.category === 'EYE'
                        ? 'OPTICS'
                        : itemCart?.frame?.category ?? '',
            Type: itemCart.frame.xitem_frameType === 'RX' ? 'RX' : 'STD',
            FrameType: 'STD', 
            LensType: upsellType,
            Engraving: '',
            Price: getItemDiscountedTotalPriceUpsell(itemCart),
            PriceFull: getItemTotalPriceUpsell(itemCart),
            Units: '1',
            Sku: itemCart.model + itemCart.color_code + itemCart.size,
            ModelName: !!itemCart.modelName ? itemCart.modelName : '',
            Shape: !!itemCart.frameshape ? itemCart.frameshape : '',
            FrameTechnology: !!itemCart.material ? itemCart.material : '',
            FrameColor: !!itemCart.color ? itemCart.color : '',
            LensTechnology: !!itemCart.rxc_lens_thickness ? itemCart.rxc_lens_thickness : '',
            Warranty: '0',
            Brand: !!itemCart.brand ? itemCart.brand : '',
            Preorder: '',
            Visibility: '',
            Badges: '',
            InsuranceAmount: getInsuranceAmount(itemCart), //DA VALUTARE
            InsuranceCode: getInsuranceCode(),
            InsuranceBenefits: getInsuranceBenefits(),
            LensAntiblue: upsell.lensPackage.blueLight,
            LensAntiReflective: upsell.lensPackage.antiReflective == null ? 'antiReflectiveStandard' : 'antiReflectivePremium',
            LensBrand: upsell.lensPackage.brand,
            LensColor: upsell.lensPackage.color,
            LensTreatment: upsell.lensPackage.treatment,
            ModelCode: !!itemCart.model ? itemCart.model : '',
            Moco: itemCart.model + itemCart.color_code,
            Lens: !!itemCart.partNumber_lenses ? itemCart.partNumber_lenses.replace('_SKU', '') : '',
            Frame: !!itemCart.partNumber_frame ? itemCart.partNumber_frame.replace('_SKU', '') :  '',
            Case: '',
            Size: itemCart.size,
            Cloth: '',
            Image: !!itemCart.frame.xitem_rxcImagery && !!itemCart.frame.xitem_rxcImagery.productImage ? itemCart.frame.xitem_rxcImagery.productImage : config.assetsUrl + itemCart.frame.partNumber + '__002.png?impolicy=GL_parameters_transp',
            Url: config.hostname + '/gl-us/eyewear/' + itemCart.frame.partNumber,
        }

        return obj;
    }

    const makeOrderCalculate = async () => {
        var payload = {};
        var jsonInsurance = RiaHelper.loadJsonInsurance();
        if (jsonInsurance != null) {
            payload.riaInsuranceInformation = jsonInsurance.riaInsuranceInformation;
        }
        payload.chooseBenefit = itemCart.frame.hasInsuranceCalculated;	
        payload.storeId = config.storeId;
        payload.catalogId = config.catalogId;
        payload.langId = config.langId;
        payload.URL='';
        payload.updatePrices = '1';
        
        payload.orderId = '.';
        payload.calculationUsageId = '-1';

        if(jsonInsurance != null && '' != jsonInsurance.patientInfo.insuranceName) {
            payload.insuranceName = jsonInsurance.patientInfo.insuranceName
        }
    
        // Converte il payload in formato URL encoded
        const formBody = Object.keys(payload)
          .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`)
          .join('&');
    
          await orderCalculate(config.hostname, formBody).then((response: any) => {
            if (itemCart.frame.hasInsuranceCalculated) {    
                dispatch(actions.setInsurance(undefined));
                dispatch(actions.setInsurance(true));
            }
            dispatch(actions.getCart(config.mockRequests, config.hostname));
            dispatch(actions.setDisableNavigation(-1));
          })
      };
    
    const priceButtonCalc = () => {
        return <>
            <div className="upsell-price-container">
                {((upsellOption.lensPackage.listPrice != upsellOption.lensPackage.offerPrice) && !itemCart.frame.hasInsuranceApplied) &&
                    <span className="upsell-full-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice) + parseFloat(itemCart.addOns.finalPrice)))}</span>}
                {!itemCart.frame.hasInsuranceApplied &&
                    <span className="upsell-offer-price">+${convertNumber(parseFloat(upsellOption.lensPackage.offerPrice) - (parseFloat(itemCart.lenses.finalDiscountPrice) + parseFloat(itemCart.addOns.finalDiscountPrice)))}</span>}
                {itemCart.frame.hasInsuranceApplied &&
                    <span className="upsell-offer-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalDiscountPrice) + parseFloat(itemCart.addOns.finalDiscountPrice)))}</span>}
            </div>
        </>
    }
    

    return(
        <>
            <div className="upsell-option">
                <Image 
                    width={"64px"}
                    height={"64px"}
                    src={upsellEspot[upsellType].icon}
                    alt={upsellType}
                />
                <div className="upsell-description">
                    <p className="title">{upsellEspot[upsellType].title}</p>
                    <p className="short-description">{upsellEspot[upsellType].short_description} <button data-analytics_available_call='0' className="primary-button long-description" onClick={() =>{
                                    activeModalUpsell();                       
                                }}>Learn more</button>
                                {upsellModal &&
                                    <UpsellDetailsModal close={() => {
                                       deactiveModalUpsell();
                                    }} UpsellDetails={upsellEspot[upsellType]}/>
                                }</p>
                </div>
                <div className="upsell-right-container">
                    {!itemCart.frame.hasInsuranceCalculated &&
                    <>
                        <div className="upsell-price-container">
                            {((upsellOption.lensPackage.listPrice != upsellOption.lensPackage.offerPrice) && !itemCart.frame.hasInsuranceApplied) &&
                                <span className="upsell-full-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice) + parseFloat(itemCart.addOns.finalPrice)))}</span>
                            }
                            {!itemCart.frame.hasInsuranceApplied &&
                                <span className="upsell-offer-price">+${convertNumber(parseFloat(upsellOption.lensPackage.offerPrice) - (parseFloat(itemCart.lenses.finalDiscountPrice) + parseFloat(itemCart.addOns.finalDiscountPrice)))}</span>
                            }
                            {itemCart.frame.hasInsuranceApplied && 
                                <span className="upsell-offer-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalDiscountPrice) + parseFloat(itemCart.addOns.finalDiscountPrice)))}</span>
                            }
                        </div>
                        {itemCart.frame.hasInsuranceApplied &&
                            <button key={'add-upsell'} data-element-id='CartUpsell_AddCart' disabled data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD</button>                
                        }
                        {!itemCart.frame.hasInsuranceApplied &&
                            <button key={'add-upsell'} data-element-id='CartUpsell_AddCart' data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD</button>                
                        }
                    </>
                    }
                    {itemCart.frame.hasInsuranceCalculated &&
                    <>
                        <div className="upsell-insurance-price-container">
                            {!!insuranceDeltaPrice && (convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice))) > insuranceDeltaPrice) &&
                                <span className="upsell-full-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice)))}</span>
                            }
                            {!insuranceDeltaPrice &&
                                <Loader classes={"green small"}/>
                            }
                            {!!insuranceDeltaPrice &&
                                <span className="upsell-offer-price">+${insuranceDeltaPrice}</span>
                            }
                        </div>
                        <button key={'add-upsell'} data-element-id='CartUpsell_AddCart' data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD</button>                
                    </>
                    }
                    
                </div>
            </div>    
            <div className="upsell-option-B">
                <div className="upsell-top-container">
                    <Image 
                        width={"64px"}
                        height={"64px"}
                        src={upsellEspot[upsellType].icon}
                        alt={upsellType}
                    />
                    <div className="upsell-description">
                        <p className="title">{upsellEspot[upsellType].title}</p>
                        <p className="short-description">{upsellEspot[upsellType].short_description}
                        <button data-analytics_available_call='0' className="primary-button long-description-desk" onClick={() =>{
                                        activeModalUpsell();                       
                                    }}>Learn more</button>
                                    {upsellModal &&
                                        <UpsellDetailsModal close={() => {
                                        deactiveModalUpsell();
                                        }} UpsellDetails={upsellEspot[upsellType]}/>
                                    }
                        </p>
                    </div>
                </div>
                <div className="upsell-right-container">
                    {!itemCart.frame.hasInsuranceCalculated && 
                    <>
                        {itemCart.frame.hasInsuranceApplied && 
                        <>
                            <button data-analytics_available_call='0' className="primary-button long-description-mob" onClick={() =>{
                                activeModalUpsell();                       
                            }}>Learn more</button>

                            <button key={'add-upsell'} disabled data-element-id='CartUpsell_AddCart' data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD FOR  
                                {priceButtonCalc()}
                            </button>
                        </>    
                        }
                        {!itemCart.frame.hasInsuranceApplied && 
                        <>
                            <button data-analytics_available_call='0' className="primary-button long-description-mob" onClick={() =>{
                                activeModalUpsell();                       
                            }}>Learn more</button>

                            <button key={'add-upsell'} data-element-id='CartUpsell_AddCart' data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD FOR  
                                {priceButtonCalc()}
                            </button> 
                        </>      
                        }
                    </>
                    }
                    {itemCart.frame.hasInsuranceCalculated &&
                        <button key={'add-upsell'} data-element-id='CartUpsell_AddCart' data-description={upsellOption.lensPackage.upc} className="violet-button add-button" onClick={() =>handleAddUpsellToCart(upsellOption, upsellEspot[upsellType].title)}>ADD FOR  
                        <div className="upsell-insurance-price-container">
                            {!!insuranceDeltaPrice && (convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice))) > insuranceDeltaPrice) &&
                                <span className="upsell-full-price">+${convertNumber(parseFloat(upsellOption.lensPackage.listPrice) - (parseFloat(itemCart.lenses.finalPrice) + parseFloat(itemCart.addOns.finalPrice)))}</span>
                            }
                            {!insuranceDeltaPrice &&
                                <Loader classes={"white small"}/>
                            }
                            {!!insuranceDeltaPrice &&
                                <span className="upsell-offer-price">+${insuranceDeltaPrice}</span>
                            }
                        </div>
                        </button> 
                    }       
                </div>
            </div>
        </>
    )

    
}

export default UpsellElement;

